import React from 'react'
import { useState, useRef, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { FaBook, FaGraduationCap } from 'react-icons/fa'

import LoadingSnipper from '../Components/Common/LoadingSnipper';
import ErrorMessage from '../Components/Common/ErrorMessage';
import useQuizzesOnce from '../Components/Hooks/useQuizzesOnce';
import QuizPreview from '../Components/Quizzes/QuizPreview';
import useUserHook from '../Components/Hooks/useUser';
import SearchTool from '../Components/SearchTool';
import LearningLayout from '../Components/LearningPlatform/LearningLayout';
import '../Components/LearningPlatform/learningPlatform.scss'

function ExerciseSection({ title, quizzes, sectionId, gradientClass }) {
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    if (quizzes.length === 0) {
        return null;
    }

    return (
        <div id={sectionId} className='scroll-mt-20 pt-8'>
            <div className='mb-0'>
                <h2 className={`font-bold rounded-xl w-full text-white text-2xl md:text-3xl text-center shadow-lg ${gradientClass} py-5 px-6`}>
                    {title}
                </h2>
            </div>
            <div className='bg-white/80 backdrop-blur-sm rounded-b-2xl p-8 shadow-lg border border-t-0 border-white/50'>
                <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6'>
                    {quizzes.map((quiz) => (
                        <div
                            className="learning-card bg-white rounded-xl shadow-md border-2 border-gray-200 hover:border-purple-300 hover:shadow-lg transition-all duration-300 min-h-[180px]"
                            key={quiz.id}
                        >
                            <QuizPreview id={quiz.id} data={quiz.data} scrollToTop={scrollToTop} />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
function Grammar() {
    const quizData = useQuizzesOnce();
    const user = useUserHook();
    const location = useLocation();

    useEffect(() => {
        // Handle hash-based scrolling
        if (location.hash) {
            const sectionId = location.hash.substring(1); // Remove the '#'
            setTimeout(() => {
                const element = document.getElementById(sectionId);
                if (element) {
                    // Find the scrollable container (the flex-1 overflow-auto div)
                    const scrollContainer = element.closest('.flex-1.overflow-auto');
                    if (scrollContainer) {
                        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    } else {
                        element.scrollIntoView({ behavior: 'smooth' });
                    }
                }
            }, 200); // Increased delay to ensure DOM is fully rendered
        }
    }, [location.hash]);

    if (quizData.status === "loading") return <LoadingSnipper />;
    if (quizData.status === "error") return <ErrorMessage>Something went wrong</ErrorMessage>;

    const introQuizzes = quizData.results.filter((quiz) => quiz.data.level === "Intro");
    const nível1Quizzes = quizData.results.filter((quiz) => quiz.data.level === "Nível 1");
    const nível2Quizzes = quizData.results.filter((quiz) => quiz.data.level === "Nível 2");
    const nível3Quizzes = quizData.results.filter((quiz) => quiz.data.level === "Nível 3");

    return (
        <LearningLayout>
            <div className='flex-1 overflow-auto flex flex-col'>
                {/* Page Content */}
                <div className='flex-1 overflow-auto'>
                    <div className='container mx-auto px-4 sm:px-6 lg:px-8 py-8'>
                        <div className='space-y-12 max-w-6xl mx-auto'>
                            <ExerciseSection
                                title="Introdução"
                                quizzes={introQuizzes}
                                sectionId="intro-section"
                                gradientClass="bg-gradient-to-r from-purple-600 to-indigo-600"
                            />
                            <ExerciseSection
                                title="Nível 1 - PRESENTE"
                                quizzes={nível1Quizzes}
                                sectionId="nivel1-section"
                                gradientClass="bg-gradient-to-r from-emerald-500 to-teal-600"
                            />
                            <ExerciseSection
                                title="Nível 2 - FUTURO"
                                quizzes={nível2Quizzes}
                                sectionId="nivel2-section"
                                gradientClass="bg-gradient-to-r from-orange-500 to-red-500"
                            />
                            <ExerciseSection
                                title="Nível 3 - PASSADO"
                                quizzes={nível3Quizzes}
                                sectionId="nivel3-section"
                                gradientClass="bg-gradient-to-r from-blue-600 to-slate-700"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </LearningLayout>
    );
}

export default Grammar
